import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import Layout from '../components/Layout';

const FileManager = () => {
  const { id } = useParams(); // current folder id
  const [files, setFiles] = useState([]);
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [file, setFile] = useState(null);
  const [reload, setReload] = useState(false);

  const token = localStorage.getItem("token");

  useEffect(() => {
    fetchFiles();
    buildBreadcrumb(id);
  }, [id, reload]);

  const fetchFiles = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/files/folder/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setFiles(res.data || []);
    } catch (error) {
      console.error("Failed to fetch files", error);
    }
  };

  const buildBreadcrumb = async (folderId) => {
    const path = [];
    let currentId = folderId;

    while (currentId) {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/folders/${currentId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const folder = res.data;
        path.unshift({ id: folder.id, name: folder.name });
        currentId = folder.parent_id;
      } catch (err) {
        break;
      }
    }

    setBreadcrumbs(path);
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const uploadFile = async (e) => {
    e.preventDefault();
    if (!file || file.type !== "application/pdf") {
      alert("Please select a valid PDF file.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append('name', file.name);
    formData.append("folder_id", id);

    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/files`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      setFile(null);
      setReload(!reload);
    } catch (err) {
      alert("Upload failed");
    }
  };

  const deleteFile = async (fileId) => {
    if (!window.confirm("Delete this file?")) return;

    try {
      await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/files/${fileId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setReload(!reload);
    } catch (err) {
      alert("Failed to delete file");
    }
  };

  return (
     <Layout>
    <div className="p-6">
        <div className='login-wrap mt-5'> 
      <h2 className="text-xl font-bold mb-3">File Manager</h2>

      {/* Breadcrumb Path */}
      <div className="text-gray-700 mb-5">
        <strong>You are in:</strong>{" "}
        {breadcrumbs.map((b, idx) => (
          <span key={b.id}>
            {b.name}
            {idx !== breadcrumbs.length - 1 && " → "}
          </span>
        ))}
      </div>

      {/* Upload Form */}
      <form onSubmit={uploadFile} className="mb-6">
        <input
          type="file"
          accept="application/pdf"
          onChange={handleFileChange}
          className="mr-2"
        />
        <button
          type="submit"
          className="bg-blue-500 text-white px-4 py-1 rounded"
        >
          Upload PDF
        </button>
      </form>

      </div>

      {/* Files Table */}
      <table className="w-full   table-basic">
        <thead>
          <tr className="bg-gray-200">
            <th className="p-2 border">File Name</th>
            <th className="p-2 border">Actions</th>
          </tr>
        </thead>
        <tbody>
          {files.length > 0 ? (
             files.map((file, index) => {

  const extension = file.file_url.split('.').pop().toLowerCase();
  const isPdf = extension === "pdf";

  return (
              <tr key={file.id} className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}>
                <td className="p-2 border">{file.name}</td>
                <td className="p-2 border space-x-2">
                  <a
                    href={file.file_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 underline btn btn-view  me-2"
                  >
                    View
                  </a>
                  <a
                    href={file.file_url}
                    download
                    className="text-green-600 underline btn btn-warning  me-2"
                  >
                    Download
                  </a>
                  <button
                    onClick={() => deleteFile(file.id)}
                    className="text-red-600 underline btn btn-danger"
                  >
                    Delete
                  </button>
                </td>
              </tr>
              ) })
          ) : (
            <tr>
              <td colSpan="2" className="text-center p-4">
                No files found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
    </Layout>
  );
};

export default FileManager;
